import MobileDetect from 'mobile-detect';
import { languages, StringList } from './lang';

export const MD = new MobileDetect(navigator.userAgent);

export const LANGTAG = document.getElementById('_lang')?.innerText || 'ru';

// @ts-ignore
export const LANGUAGE = <StringList>languages[<keyof languages>LANGTAG];